import "./HomeInspectionInHomesteadFL.module.css";
import Header from "@/reusable_sections/Header";
import IndustryOverview from "./sections/IndustryOverview";
import PracticeAreas from "./sections/PracticeAreas";
import WhyChooseUs from "./sections/WhyChooseUs";
import WhyOperatorsChooseNeonGen from "./sections/WhyOperatorsChooseNeonGen";
import PhotoCredit from "./sections/PhotoCredit";
import RequestAQuote from "./sections/RequestAQuote";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function HomeInspectionInHomesteadFLPage() {
  return <div>
      <Header />
      <IndustryOverview />
      <PracticeAreas />
      <WhyChooseUs />
      <WhyOperatorsChooseNeonGen />
      <PhotoCredit />
      <RequestAQuote />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}